/**
 * Maps API values to the two-option form (Estándar / Personalizada).
 * Legacy `minimal` is shown and saved as standard.
 */
export function normalizeInvoiceEmailTemplateForForm(
  template: string | undefined,
  canUseCustom: boolean
): "default" | "custom" {
  if (template === "minimal") return "default";
  if (template === "custom" && !canUseCustom) return "default";
  if (template === "custom") return "custom";
  return "default";
}
